// extracted by mini-css-extract-plugin
module.exports = {"lock":"Lock_lock__yDpOJ","lock-icon":"Lock_lock-icon__2ilOh","lock-button":"Lock_lock-button__3Zoh3"};